import { BP, Colors, Mixins, Typography, mq } from '~/styles';
import type { TStyleSheet } from '~/types/emotion-styles';

const styles: TStyleSheet = {
  backButton: {
    ...Typography.metadataSmall,
    ...Mixins.transition('color'),
    background: Colors.audacyDarkNavy,
    color: Colors.white60,
    ':hover': {
      background: Colors.audacyDarkNavy,
      color: Colors.white,
    },
  },
  // back button is a pill with same bg color as page, adjust for button padding so that content aligns with left gutter
  // note: using the pill here because once entity hero images are implemented the bg color will be visible
  back: {
    marginLeft: -13,
    [mq(BP.Medium)]: {
      marginLeft: 26,
    },
  },
};

export default styles;
